import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {simpleListHeader_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/simpleListHeader_template";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";


declare var ko: any;

export class topicalityReport_template extends vnTemplate {

    public filterBrands: multipleSelector_template;
    public filterInitiatives: multipleSelector_template;
    public filterIntents: multipleSelector_template;
    public filterContentTypes: multipleSelector_template;
    public filterGoogleSources: multipleSelector_template;
    public filterDates: filterDate_template;
    public filterTags: filterMultipleAutoComplete_template;
    public filterTagTypes: filterMultipleAutoComplete_template;
    public primaryCategoriesFilter : filterMultipleAutoComplete_template;

    protected pagination: pagination_template;

    protected exportDataCsv: exportDataCsv;

    protected headers: simpleListHeader_template;

    public presetFilter: presetFilter_template;

    public validationsList: validationsList_template;

    public minArticles;
    public maxArticles;

    readonly viewModes = [

        {"id": "tag", "name": "Tag"},
    ];

    readonly dataSources= [

        {"id": "ga", "name": "Google Analytics"},
        {"id": "sc", "name": "Search Console"},
    ];


    readonly googleSources= [

        {"id": "search", "name": "Search"},
        {"id": "discover", "name": "Discover"},
        {"id": "news", "name": "News"},
    ];

    readonly gaDataSourceHeaders = [

        {headerName: "Tag", fieldName: "tagName", subHeaders: []},
        {headerName: "Tag Type", fieldName: "typeName", subHeaders: []},
        {headerName: "Art. Pub.", fieldName: "nbPublishedArticles", subHeaders: []},
        {headerName: "Art. Repub.", fieldName: "nbRepublishedArticles", subHeaders: []},
        {headerName: "Sessions", fieldName: "sessions", subHeaders: []},
        {headerName: "Sess/Art.", fieldName: "sessionsPerArticle", subHeaders: []},
        {headerName: "% of Total", fieldName: "sessionsOfTotal", subHeaders: []},
        {headerName: "Act. Sess.", fieldName: "activeSessions", subHeaders: []},
        {headerName: "Act. Sess./Art. Pub.", fieldName: "activeSessionsPerArticle", subHeaders: []},
        {headerName: "Success Rate", fieldName: "successRate", subHeaders: []},
        {headerName: "Failure Rate", fieldName: "failureRate", subHeaders: []},
        {headerName: "Trend", fieldName: "", subHeaders: []},
    ];

    readonly scDataSourceHeaders = [

        {headerName: "Tag", fieldName: "tagName", subHeaders: []},
        {headerName: "Tag Type", fieldName: "typeName", subHeaders: []},
        {headerName: "Art. Pub.", fieldName: "nbPublishedArticles", subHeaders: []},
        {headerName: "Art. Repub.", fieldName: "nbRepublishedArticles", subHeaders: []},
        {headerName: "Clicks", fieldName: "clicks", subHeaders: []},
        {headerName: "Clicks/Art.", fieldName: "clicksPerArticle", subHeaders: []},
        {headerName: "% of Total", fieldName: "clicksOfTotal", subHeaders: []},
        {headerName: "Impressions", fieldName: "impressions", subHeaders: []},
        {headerName: "CTR", fieldName: "ctr", subHeaders: []},
        {headerName: "Trend", fieldName: "", subHeaders: []},
        {headerName: "Distribution", fieldName: "", subHeaders: []},
    ];

    protected getTemplateHtml(): string {

        return `
            <div class="sub-header">
                
                <div class="w-justify">
                
                    ${this.presetFilter.getHtmlBuild()}

                    <div class="w-left">
                    
                        <div class="dropdown select-single">
                            <label class="form-label" for="">View Mode</label>
                            <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelectedText"></button>
                            
                            <div class="dropdown-list"> 
                                <div class="w-form">   
                                    <div class="form-group" data-bind="foreach: viewModes">
                                        <input type="radio" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                        <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div>
                            ${this.filterBrands.getHtmlBuild()}
                        </div>
                        
                        <div>
                            ${this.filterInitiatives.getHtmlBuild()}
                        </div>
                        
                        <div>
                            ${this.filterIntents.getHtmlBuild()}
                        </div>
                        
                        <div>
                            ${this.filterContentTypes.getHtmlBuild()}
                        </div>
                    
                        <!-- ko if: trafficSource() == 1 -->

                            <div class="dropdown select-single">
                                
                                <label class="form-label" for="">Data Source</label>
                                <button class="dropdown-toggle" type="button" data-bind="text: dataSourceSelectedText"></button>

                                <div class="dropdown-list">
                                    <div class="w-form">
                                        <div class="form-group" data-bind="foreach: dataSources">
                                            <input type="radio" data-bind="checked : $parent.dataSourceSelected, value: id,  attr: { 'id': 'dataSource_' + id, 'name' : 'dataSource_' + id }, event:{ change: $parent.onDataSourceChange}">
                                            <label class="form-label" data-bind="attr: {for : 'dataSource_' + id }, text: name"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div data-bind="visible: dataSourceSelected() === 'sc'">
                                ${this.filterGoogleSources.getHtmlBuild()}
                            </div>
                        <!-- /ko -->

                        
                        <div>
                            ${this.filterDates.getHtmlBuild()}
                        </div>
                        
                        <div class="w-spec-search icon i-article-a">
                            <input placeholder="Min Art.Pub" type="number" data-bind="value: minArticles, event:{ keyup: onMinArticlesChange }, valueUpdate: 'afterkeydown', attr:{id: 'min_articles'}, css: 'input-text'" />
                            <button data-bind="event: { click: onClearMinArticles }, css: { 'is-showing' : minArticles }" class="close-btn icon i-x-after" id="close-btn" type="button"></button>
                        </div>
                        
                        <div class="w-spec-search icon i-article-a">
                            <input placeholder="Max Art.Pub" type="number" data-bind="value: maxArticles, event:{ keyup: onMaxArticlesChange }, valueUpdate: 'afterkeydown', attr:{id: 'max_articles'}, css: 'input-text'" />
                            <button data-bind="event: { click: onClearMaxArticles }, css: { 'is-showing' : maxArticles }" class="close-btn icon i-x-after" id="close-btn" type="button"></button>
                        </div>

                        <div>
                            ${this.filterTags.getHtmlBuild()}
                        </div>
                        
                        <div>
                            ${this.filterTagTypes.getHtmlBuild()}
                        </div>
                        
                        <div data-bind="css: {disabledDiv: filterBrands.selectedItems().length != 1}">
                            ${this.primaryCategoriesFilter.getHtmlBuild()}
                        </div>
                    </div>
                </div>   
            </div>

            ${this.validationsList.getHtmlBuild()}
                        
            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-brands"></div>
                    <div id="selected-initiatives"></div>
                    <div id="selected-intents"></div>
                    <div id="selected-content-types"></div>
                    <div id="selected-google-sources" data-bind="visible: dataSourceSelected() === 'sc'"></div>
                    <div id="selected-tags"></div>
                    <div id="selected-tag-types"></div>
                    <div id="selected-primary-categories" data-bind="visible: filterBrands.selectedItems().length == 1"></div>
                </div>
            </div>

            <div class="list-header w-justify">
                <div>
                    <h2 class="section-title icon i-tag">Tag Performance Report</h2>
                    <div>
                        <label class="toggle">
                            <span class="toggle-label" data-bind="css: (trafficSource() == 1) ? 'is-activated' : ''">GA4</span>
                            <input class="toggle-checkbox" data-bind="event: {change: onToggleTrafficSource}, checked: (trafficSource() == 2)" type="checkbox">
                            <div class="toggle-switch"></div>
                            <span class="toggle-label" data-bind="css: (trafficSource() == 2) ? 'is-activated' : ''">Sentinel</span>
                        </label>
                    </div>
                </div>
                <div class="w-right"> 
                    ${this.pagination.getHtmlBuild()}
                    <button class="btn icon highlight i-export" type="button" data-bind="event: {click: onExportData}">Export</button>
                </div>
            </div>
            <div class="list-header w-justify">
                <ul class="tooltip-tag-view">
                    <li>Select a single brand to view Article level details or enable the Primary Category filter.</li>
                </ul>
            </div>
            <div class="w-list-results"  id="list-results" >
                    <table class="list-results" data-bind="visible: !isReportLoading(); css: { loading: isReportLoading }">
                        
                        <thead>
                            ` + this.headers.getHtmlBuild()  + `
                        </thead>                    
                        
                        <tbody data-bind="foreach: tableData">        
                        <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                            
                                <!-- ko if: $parent.filterBrands.selectedItems().length == 1 -->
                                    <td><a data-bind="attr: { href: '/tag_performance_article_report/brand/' + $parent.filterBrands.selectedItems()[0] + '/tag/' + idTag + '/?' + window.location.href.split('?')[1]}"><span class="no-wrap icon i-ext-link" data-bind="text: tagName"></span></a></td>
                                <!-- /ko -->
                                
                                <!-- ko if: $parent.filterBrands.selectedItems().length != 1 -->
                                    <td><span data-bind="text: tagName"></span></td>
                                <!-- /ko -->  
                                
                                <td><span data-bind="text: typeName"></span></td>
                                <td><span data-bind="text: Number(nbPublishedArticles).toLocaleString('en-EG')"></span></td>
                                <td><span data-bind="text: Number(nbRepublishedArticles).toLocaleString('en-EG')"></span></td>
                                        
                                <!-- ko if: $parent.trafficSource() == 2 || $parent.dataSourceSelected() == "ga" -->
                                    <td><span data-bind="text: Number(sessions).toLocaleString('en-EG')"></span></td>
                                    <td><span data-bind="text: Number(sessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td><span data-bind="text: Number(sessionsOfTotal).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>                                    
                                    <td><span data-bind="text: Number(activeSessions).toLocaleString('en-EG')"></span></td>
                                    <td><span data-bind="text: (activeSessionsPerArticle != null && nbPublishedArticles != 0) ? Number(activeSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''"></span></td>
                                    <td class="align-left" style="padding-left: 0;padding-right: 0;" data-bind="attr: {title: 'Success rate based on a blended sessions target of ' + Number(blendedSuccessTargetSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' sessions per published article.'}">
                                        <div class="flex">
                                            <span style="margin-left: 2rem;" data-bind="text: (successRate != null && blendedSuccessTargetSessions != 0 && blendedSuccessTargetSessions != 0) ? Number(successRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : ''"></span>
                                        </div>
                                    </td>
                                    <td class="align-left" style="padding-left: 0;padding-right: 0;" data-bind="attr: {title: 'Failure rate based on ' + (Number(isPassedCount) + Number(isFailureCount)) + ' articles out of ' + (Number(isPassedCount) + Number(isFailureCount) + Number(isPendingCount)) + '.'}, css: { 'is-empty': Number(isPendingCount) == 0 && Number(isPassedCount) == 0 && Number(isFailureCount) == 0, 'is-pending': Number(isPendingCount) > 0 && Number(isPassedCount) == 0 && Number(isFailureCount) == 0, 'is-running': Number(isPendingCount) > 0 && (Number(isPassedCount) > 0 || Number(isFailureCount) > 0) }">
                                        <div class="flex">
                                            <span style="margin-left: 2rem;" data-bind="text: (failureRate != null) ? Number(failureRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : ''"></span>
                                        </div>
                                    </td>
                                <!-- /ko -->  
                                
                                <!-- ko if: $parent.trafficSource() == 1 && $parent.dataSourceSelected() == "sc" -->
                                    <td><span data-bind="text: Number(clicks).toLocaleString('en-EG')"></span></td>
                                    <td><span data-bind="text: Number(clicksPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td><span data-bind="text: Number(clicksOfTotal).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%'"></span></td>
                                    <td><span data-bind="text: Number(impressions).toLocaleString('en-EG')"></span></td>
                                    <td><span data-bind="text: ctr + '%'"></span></td>
                                <!-- /ko -->
                                
                                <td><div style="width: 120px; height: 70px; border: 1px dotted #eee;" data-bind="attr: { 'id': 'trend-' + idTag }"></div></td>
                                
                                <!-- ko if: $parent.trafficSource() == 1 && $parent.dataSourceSelected() == "sc" -->
                                    <td style="width: 350px;">
                                        <div class="w-per-bar" data-bind="attr: { title: 'Search: ' + searchDistribution + '% Discover: ' + discoverDistribution + '% News: ' + googleNewsDistribution + '%'}">
                                            <span class="pre-bar search" data-bind="style: { width: searchDistribution + '%' }"></span>
                                            <span class="pre-bar discover" data-bind="style: { width: discoverDistribution + '%' }"></span>
                                            <span class="pre-bar googlenews" data-bind="style: { width: googleNewsDistribution + '%' }"></span>
                                        </div>
                                    </td>
                                <!-- /ko -->    
                            </tr>                 
                        <tbody>
                        <tfoot>
                        </tfoot>
                    </table>
                </div>
            `;
    }

    protected initPartial(): void {

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('topicalityReport');

        this.filterBrands = new multipleSelector_template("filterBrands", this.getTemplateViewModel(), this.caller);
        this.filterBrands.setTagContainerId('selected-brands');
        this.filterBrands.setTagContainerCaption('Selected Brands:');
        this.filterBrands.setLabel("Brands");
        this.filterBrands.setLogoEnabled(true);

        this.filterInitiatives = new multipleSelector_template("filterInitiatives", this.getTemplateViewModel(), this.caller);
        this.filterInitiatives.setTagContainerId('selected-initiatives');
        this.filterInitiatives.setTagContainerCaption('Selected mappings:');
        this.filterInitiatives.setLabel("Mappings");

        this.filterIntents = new multipleSelector_template("filterIntents", this.getTemplateViewModel(), this.caller);
        this.filterIntents.setTagContainerId('selected-intents');
        this.filterIntents.setTagContainerCaption('Selected Intents:');
        this.filterIntents.setLabel("Intents");

        this.filterContentTypes = new multipleSelector_template("filterContentTypes", this.getTemplateViewModel(), this.caller);
        this.filterContentTypes.setTagContainerId('selected-content-types');
        this.filterContentTypes.setTagContainerCaption('Selected Content Types:');
        this.filterContentTypes.setLabel("Content Types");

        this.filterGoogleSources = new multipleSelector_template("filterGoogleSources", this.getTemplateViewModel(), this.caller);
        this.filterGoogleSources.setTagContainerId('selected-google-sources');
        this.filterGoogleSources.setTagContainerCaption('Selected Google Sources:');
        this.filterGoogleSources.setLabel("Google Sources");

        let startDate = new Date();
        startDate.setHours(0,0,0,0);
        startDate.setDate(startDate.getDate() - 30);
        let endDate = new Date();
        endDate.setHours(0,0,0,0);
        endDate.setDate(endDate.getDate() - 1);

        this.filterDates = new filterDate_template("filterDates", this.getTemplateViewModel(), this.caller);
        this.filterDates.setDateRange(startDate, endDate);

        this.primaryCategoriesFilter = new filterMultipleAutoComplete_template("primaryCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.primaryCategoriesFilter.setIsVisible(1);
        this.primaryCategoriesFilter.setPlaceHolderText("Primary Category");
        this.primaryCategoriesFilter.setIcon("i-tag-a");
        this.primaryCategoriesFilter.setTagContainerId('selected-primary-categories');
        this.primaryCategoriesFilter.setTagContainerCaption('Selected Primary Categories:');
        this.primaryCategoriesFilter.setMinInputSuggestionLength(2);

        this.filterTags = new filterMultipleAutoComplete_template("filterTags", this.getTemplateViewModel(), this.caller);
        this.filterTags.setIsVisible(1);
        this.filterTags.setPlaceHolderText("Tag Search");
        this.filterTags.setIcon("i-tag-a");
        this.filterTags.setTagContainerId('selected-tags');
        this.filterTags.setTagContainerCaption('Selected Tags:');
        this.filterTags.setMinInputSuggestionLength(2);

        this.filterTagTypes = new filterMultipleAutoComplete_template("filterTagTypes", this.getTemplateViewModel(), this.caller);
        this.filterTagTypes.setIsVisible(1);
        this.filterTagTypes.setPlaceHolderText("Tag Type Search");
        this.filterTagTypes.setIcon("i-tag-a");
        this.filterTagTypes.setTagContainerId('selected-tag-types');
        this.filterTagTypes.setTagContainerCaption('Selected Tag Types:');
        this.filterTagTypes.setMinInputSuggestionLength(2);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.exportDataCsv = new exportDataCsv();

        this.headers = new simpleListHeader_template("listHeader", this.getTemplateViewModel(), this.caller, []);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);
    }

    protected getTemplateName(): string {

        return "topicalityReport_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            tableData: ko.observableArray([]),
            exportData: ko.observableArray([]),
            viewModes: ko.observableArray([]),
            viewModeSelected: ko.observable("tag"),
            viewModeSelectedText: ko.observable("Tag"),
            dataSources: ko.observableArray([]),
            dataSourceSelected: ko.observable("ga"),
            dataSourceSelectedText: ko.observable("Google Analytics"),
            minArticles: ko.observable(null),
            maxArticles: ko.observable(null),
            isReportLoading: ko.observable(0),
            selectedRows: ko.observableArray([]),
            trafficSource : ko.observable(2),
            onMinArticlesChange: function () {
                huit_neuf_this.onMinArticlesChange();
            },
            onMaxArticlesChange: function () {
                huit_neuf_this.onMaxArticlesChange();
            },
            onClearMinArticles: function (data, event) {
                huit_neuf_this.onClearMinArticles(event);
            },
            onClearMaxArticles: function (data, event) {
                huit_neuf_this.onClearMaxArticles(event);
            },
            onViewModeChange: function (data) {
                huit_neuf_this.onViewModeChange(data);
            },
            onDataSourceChange: function (data) {
                huit_neuf_this.onDataSourceChange(data);
            },
            onExportData: function() {
                huit_neuf_this.onExportData();
            },
            onClickRowClick: function(index, data){
                huit_neuf_this.onClickRowClick(index);
                return true;
            },
            onToggleTrafficSource : function(data, event){
                huit_neuf_this.onToggleTrafficSource(data, event);
            },
        };
    }

    public onToggleTrafficSource(data, event){

        let toggleValue = this.getTemplateViewModel().trafficSource();

        if (toggleValue == 2) {

            this.getTemplateViewModel().trafficSource(1);
        }else {

            this.getTemplateViewModel().trafficSource(2);
            this.getTemplateViewModel().filterGoogleSources.selectedItems([]);
            this.getTemplateViewModel().filterGoogleSources.setTags([], []);
            this.getTemplateViewModel().dataSourceSelected("ga");
            this.getTemplateViewModel().dataSourceSelectedText("Google Analytics");
            this.setTableHeaderItems();
        }
        this.caller.getReportData();
    }
    
    public getViewModelForRequest() {

        return {
            filter: {
                viewMode: this.getTemplateViewModel().viewModeSelected(),
                idBrands: this.getTemplateViewModel().filterBrands.selectedItems(),
                idInitiatives: this.getTemplateViewModel().filterInitiatives.selectedItems(),
                idIntents: this.getTemplateViewModel().filterIntents.selectedItems(),
                idContentTypes: this.getTemplateViewModel().filterContentTypes.selectedItems(),
                dataSource: this.getTemplateViewModel().dataSourceSelected(),
                googleSources: this.getTemplateViewModel().filterGoogleSources.selectedItems(),
                minArticles: this.getTemplateViewModel().minArticles(),
                maxArticles: this.getTemplateViewModel().maxArticles(),
                dateFilterType: this.getTemplateViewModel().filterDates.selectedFilter(),
                startDate: this.getTemplateViewModel().filterDates.startDate(),
                endDate: this.getTemplateViewModel().filterDates.endDate(),
                startDateRange: this.getTemplateViewModel().filterDates.fromRange(),
                endDateRange: this.getTemplateViewModel().filterDates.toRange(),
                idPrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemIds(),
                namePrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemNames(),
                idTags: this.getTemplateViewModel().filterTags.selectedItemIds(),
                nameTags: this.getTemplateViewModel().filterTags.selectedItemNames(),
                idTagTypes: this.getTemplateViewModel().filterTagTypes.selectedItemIds(),
                nameTagTypes: this.getTemplateViewModel().filterTagTypes.selectedItemNames(),
                trafficSource: this.getTemplateViewModel().trafficSource(),
            },
            pagination: this.getTemplateViewModel().pagination,
            headers: this.headers.getViewModelForRequest(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        let container = super.build(classesToAdd);
        return container;
    }

    public buildDatePickerCalendar() {

        this.filterDates.buildCalendar();
    }

    public setViewModesItems() {

        this.getTemplateViewModel().viewModes(this.viewModes);
    }

    public setDataSourcesItems() {

        this.getTemplateViewModel().dataSources(this.dataSources);
    }

    public setBrandsItems(items) {

        let groups = [];
        for ( let department of items){
            let group = {"name" : department.name, "logo" : department.logo, "items" : department.brands};
            groups.push(group);
        }
        this.filterBrands.setMultiSectionItems(groups);
    }

    public setInitiativesItems(items) {

        for (let item of items){

            item['name'] = item['initiative'];
        }

        this.filterInitiatives.setItems(items);
    }

    public setIntentsItems(items) {

        this.filterIntents.setItems(items);
    }

    public setContentTypesItems(items) {

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.filterContentTypes.setMultiSectionItems(groups);
    }

    public setGoogleSourcesItems() {

        this.filterGoogleSources.setItems(this.googleSources);
    }

    public setTableHeaderItems() {

        if (this.getTemplateViewModel().trafficSource() == 2 || this.getTemplateViewModel().dataSourceSelected() == "ga") {

            this.headers.setHeadersLevels(this.gaDataSourceHeaders);
            this.headers.getTemplateViewModel().orderBy("sessions");
            this.headers.getTemplateViewModel().orderByDirection("DESC");
            this.headers.getTemplateViewModel().orderByAndDirection("sessions_DESC");
        }else {

            this.headers.setHeadersLevels(this.scDataSourceHeaders);
            this.headers.getTemplateViewModel().orderBy("clicks");
            this.headers.getTemplateViewModel().orderByDirection("DESC");
            this.headers.getTemplateViewModel().orderByAndDirection("clicks_DESC");
        }
    }

    private onMinArticlesChange() {

        this.caller.getReportData();
    }

    private onMaxArticlesChange() {

        this.caller.getReportData();
    }

    protected onClearMinArticles(event) {
        this.getTemplateViewModel().minArticles(null);
        this.caller.getReportData();
    }

    protected onClearMaxArticles(event) {
        this.getTemplateViewModel().maxArticles(null);
        this.caller.getReportData();
    }

    private onViewModeChange(selected) {

        this.getTemplateViewModel().viewModeSelectedText(selected.name);
        this.caller.getReportData();
    }

    private onDataSourceChange(selected){

        this.getTemplateViewModel().dataSourceSelectedText(selected.name);
        this.setTableHeaderItems();
        this.caller.getReportData();
    }

    public setTagsItems(items){

        this.filterTags.setItems(items);
    }

    public setTagTypesItems(items){

        this.filterTagTypes.setItems(items);
    }

    public setPrimaryCategoriesFilterItems(items){

        this.primaryCategoriesFilter.setItems(items);
    }

    public resetPrimaryCategoriesFilter(){

        this.primaryCategoriesFilter.getTemplateViewModel().selectedItems([]);
        this.primaryCategoriesFilter.getTemplateViewModel().selectedItemIds([]);
        this.primaryCategoriesFilter.getTemplateViewModel().selectedItemNames([]);
        this.primaryCategoriesFilter.setTags([], []);
    }

    public setTableData(tableData){

        this.getTemplateViewModel().tableData(tableData);
        this.addTrendGraphs(tableData);
    }

    public addTrendGraphs(tableData) {


        for (let graphData of tableData) {

            am4core.useTheme(am4themes_animated);

            var chart = am4core.create("trend-" + graphData.idTag , am4charts.XYChart);

            if (chart.logo) {

                chart.logo.disabled = true;
            }

            chart.data = graphData.trendData;

            chart.padding(0, 0, 0, 0);

            var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.disabled = true;
            dateAxis.renderer.labels.template.disabled = true;
            dateAxis.startLocation = 0.5;
            dateAxis.endLocation = 0.7;
            dateAxis.cursorTooltipEnabled = false;

            var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            valueAxis.renderer.grid.template.disabled = true;
            valueAxis.renderer.baseGrid.disabled = true;
            valueAxis.renderer.labels.template.disabled = true;
            valueAxis.cursorTooltipEnabled = false;

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.lineY.disabled = true;

            var series = chart.series.push(new am4charts.LineSeries());
            series.tooltipText = "{date}: [bold]{value} " + ((this.getTemplateViewModel().trafficSource() == 2 || this.getTemplateViewModel().dataSourceSelected() == "ga") ? "sessions" : "clicks");
            series.dataFields.dateX = "date";
            series.dataFields.valueY = "value";
            series.tensionX = 0.8;
            series.strokeWidth = 2;

            // render data points as bullets
            var bullet = series.bullets.push(new am4charts.CircleBullet());
            bullet.circle.opacity = 0;
            bullet.circle.propertyFields.opacity = "opacity";
            bullet.circle.radius = 3;
        }
    }

    public resetPageNumber(): void {

        this.pagination.getTemplateViewModel().pageNumber(1);
    }

    public setPaginationTotalCount(totalCount: number):  void {

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    public setViewModelFromRequest(params : Array<any>): void {

        this.presetFilter.setMultiSelectorPresetFilters(this.filterBrands, params['filter']['idBrands']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterInitiatives, params['filter']['idInitiatives']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterIntents, params['filter']['idIntents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterContentTypes, params['filter']['idContentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.filterGoogleSources, params['filter']['googleSources']);

        this.presetFilter.setMultipleAutocompletePresetFilter(this.primaryCategoriesFilter, params['filter']['idPrimaryCategories'], params['filter']['namePrimaryCategories']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.filterTags, params['filter']['idTags'], params['filter']['nameTags']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.filterTagTypes, params['filter']['idTagTypes'], params['filter']['nameTagTypes']);

        this.presetFilter.setDates(this.filterDates, params['filter']['dateFilterType'], params['filter']['startDate'], params['filter']['endDate'], params['filter']['startDateRange'], params['filter']['endDateRange']);

        if (typeof params['filter']['minArticles'] !== 'undefined') {

            this.getTemplateViewModel().minArticles(params['filter']['minArticles']);
        }

        if (typeof params['filter']['maxArticles'] !== 'undefined') {

            this.getTemplateViewModel().maxArticles(params['filter']['maxArticles']);
        }

        if (params['filter']['dataSource'] == "ga") {

            this.getTemplateViewModel().dataSourceSelected("ga");
            this.getTemplateViewModel().dataSourceSelectedText("Google Analytics");
        } else {

            this.getTemplateViewModel().dataSourceSelected("sc");
            this.getTemplateViewModel().dataSourceSelectedText("Search Console");
        }

        if (typeof params['filter']['trafficSource'] !== 'undefined') {
            this.getTemplateViewModel().trafficSource(params['filter']['trafficSource']);
        }

        this.setTableHeaderItems();
    }

    private onExportData(){

        this.caller.getExportData();
    }

    public setExportData(exportData){

        let exportDataView = [];
        for (let exportDataRow of exportData) {

            let exportDataViewRow = [];
            exportDataViewRow["idTag"] = exportDataRow.idTag;
            exportDataViewRow["Tag"] = exportDataRow.tagName;
            exportDataViewRow["idTagType"] = exportDataRow.idType;
            exportDataViewRow["Tag Type"] = exportDataRow.typeName;
            exportDataViewRow["Art. Pub."] = Number(exportDataRow.nbPublishedArticles).toLocaleString('en-EG');
            exportDataViewRow["Art. Repub."] = Number(exportDataRow.nbRepublishedArticles).toLocaleString('en-EG');

            if (this.getTemplateViewModel().trafficSource() == 2 || this.getTemplateViewModel().dataSourceSelected() == "ga") {

                exportDataViewRow["Sessions"] = Number(exportDataRow.sessions).toLocaleString('en-EG');
                exportDataViewRow["Sess/Art."] = Number(exportDataRow.sessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                exportDataViewRow["% of Total"] = Number(exportDataRow.sessionsOfTotal).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
                exportDataViewRow["Act. Sess."] = Number(exportDataRow.activeSessions).toLocaleString('en-EG');
                exportDataViewRow["Act. Sess./Art. Pub."] = (exportDataRow.activeSessionsPerArticle != null && exportDataRow.nbPublishedArticles != 0) ? Number(exportDataRow.activeSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' : '';
                exportDataViewRow["Success Rate"] = (exportDataRow.successRate != null && exportDataRow.blendedSuccessTargetSessions != null && exportDataRow.blendedSuccessTargetSessions != 0) ? Number(exportDataRow.successRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : '';
                exportDataViewRow["Failure Rate"] = (exportDataRow.failureRate != null) ? Number(exportDataRow.failureRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : '';
            }
            else if (this.getTemplateViewModel().dataSourceSelected() == "sc") {

                exportDataViewRow["Clicks"] = Number(exportDataRow.clicks).toLocaleString('en-EG');
                exportDataViewRow["Clicks/Art."] = Number(exportDataRow.clicksPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                exportDataViewRow["% of Total"] = Number(exportDataRow.clicksOfTotal).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%';
                exportDataViewRow["Impressions"] = Number(exportDataRow.impressions).toLocaleString('en-EG');
                exportDataViewRow["CTR"] = exportDataRow.ctr + '%';
                exportDataViewRow["Distribution"] = 'Search: ' + exportDataRow.searchDistribution + '% Discover: ' + exportDataRow.discoverDistribution + '% News: ' + exportDataRow.googleNewsDistribution + '%';
            }

            exportDataView.push(exportDataViewRow);
        }

        this.getTemplateViewModel().exportData(exportDataView);
    }

    private exportData(obj){

        this.exportDataCsv.exportToCsv("TagPerformanceExport", this.getTemplateViewModel().exportData());
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/topicalityReport_template.ts